import { ROLE_TYPES, UI_VARIANTS } from '@/@studio-ai/constants';
import { TextDisplayProps } from '@/@studio-ai/props';
import { cn } from '@heroui/react';
import { buildMarkdownComponents, Markdown } from './markdown';

// Chat messages render at 16px body text — overrides markdown.tsx's
// default text-medium (17.6px), scoped to just this component's usage.
const CHAT_MARKDOWN_COMPONENTS = buildMarkdownComponents('text-[16px]');

export function TextDisplay({
    text,
    role = ROLE_TYPES.ASSISTANT,
    variant = UI_VARIANTS.TEXT_DISPLAY.BUBBLE,
    className = '',
}: TextDisplayProps) {
    const displayText = role === ROLE_TYPES.USER ? text.replace(/\n/g, '  \n') : text;

    if (variant === UI_VARIANTS.TEXT_DISPLAY.PLAIN) {
        return (
            <div className={cn('max-w-full overflow-x-auto', className)}>
                <Markdown components={CHAT_MARKDOWN_COMPONENTS}>{displayText}</Markdown>
            </div>
        );
    }

    return (
        <div
            className={cn(
                'flex flex-row gap-2',
                role === ROLE_TYPES.USER ? 'justify-end' : 'justify-start',
                className,
            )}
        >
            <div
                className={cn(
                    'flex max-w-full flex-col gap-4 overflow-x-auto py-3 text-foreground',
                    role === ROLE_TYPES.USER ? 'rounded-3xl bg-foreground/5 px-5 py-3' : '',
                )}
            >
                <Markdown components={CHAT_MARKDOWN_COMPONENTS}>{displayText}</Markdown>
            </div>
        </div>
    );
}
